import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "49",
  height: "48",
  viewBox: "0 0 49 48",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M44.7656 7.125V17.4375C41.1412 17.4375 38.2031 20.3756 38.2031 24C38.2031 27.6244 41.1412 30.5625 44.7656 30.5625V40.875H3.51562V30.5625C7.14 30.5625 10.0781 27.6244 10.0781 24C10.0781 20.3756 7.14 17.4375 3.51562 17.4375V7.125H44.7656Z",
      stroke: "#454342",
      "stroke-width": "2"
    }, null, -1),
    _createElementVNode("path", {
      d: "M15.707 32.5254L32.582 15.6504",
      stroke: "#454342",
      "stroke-width": "2"
    }, null, -1),
    _createElementVNode("path", {
      d: "M17.1133 17.9873L18.0508 17.0498L18.9883 17.9873L18.0508 18.9248L17.1133 17.9873Z",
      stroke: "#454342",
      "stroke-width": "2"
    }, null, -1),
    _createElementVNode("path", {
      d: "M29.3008 30.1748L30.2383 29.2373L31.1758 30.1748L30.2383 31.1123L29.3008 30.1748Z",
      stroke: "#454342",
      "stroke-width": "2"
    }, null, -1)
  ])))
}
export default { render: render }